import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation RateChat($id: ID!, $rating: Rating!) {
    rateChat(id: $id, rating: $rating) {
      id
      rating
    }
  }
`);
